import { isNaN as _isNan, isNil } from 'lodash-es';

// similar to c# StringBuilder, but with much less functionality (only a subset of functions)
// will make it easier to port code from C# to js, if necessary

const newLine = '\r\n';

export class StringBuilder {
  private baseStr: string;

  get Length() {
    return this.baseStr.length;
  }

  constructor(initialStr?: string | null) {
    this.baseStr = initialStr || '';
  }

  Append(str: any) {
    this.baseStr += str;
    return this;
  }

  AppendLine(str?: any) {
    if (!isNil(str) && !_isNan(str)) {
      this.baseStr += str;
    }
    this.baseStr += newLine;
    return this;
  }

  ToString() {
    return this.baseStr;
  }
}
